import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getUnreadCountOptions,
  getUnreadCountQueryKey,
  listNotificationsOptions,
  listNotificationsQueryKey,
  markAllAsReadMutation,
  markAsReadMutation,
} from '@/api/platform/generated/@tanstack/react-query.gen';

export function useUnreadCount() {
  const { data, ...rest } = useQuery({
    ...getUnreadCountOptions(),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });

  return {
    unreadCount: data?.unread_count ?? 0,
    ...rest,
  };
}

/** NavBadge-compatible adapter (returns `{ count }` instead of `{ unreadCount }`). */
export function useNotificationBadgeCount() {
  const { unreadCount } = useUnreadCount();
  return { count: unreadCount };
}

export function useNotifications(params?: { read?: boolean; limit?: number; offset?: number }) {
  return useQuery({
    ...listNotificationsOptions({
      query: {
        read: params?.read,
        limit: params?.limit ?? 20,
        offset: params?.offset ?? 0,
      },
    }),
    staleTime: 30_000,
  });
}

export function useMarkAsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    ...markAsReadMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listNotificationsQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getUnreadCountQueryKey(),
      });
    },
  });
}

export function useMarkAllAsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    ...markAllAsReadMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listNotificationsQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getUnreadCountQueryKey(),
      });
    },
  });
}
